export default __webpack_public_path__ + "static/media/icon-arrow.ec5e4b21.svg";